import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useNetworkStore } from "../stores/network";
import { CHART_SCOPES } from "../stores/live-charts";

/**
 * Brings the chart families up to date once, without turning live-follow on.
 *
 * Shared by the live toggle's "behind" badge, the range toolbars' "latest" button and the toggle's
 * own off→on transition, because all three mean the same thing: show me the head as it is now.
 */
export function useChartCatchUp() {
  const queryClient = useQueryClient();
  const { selectedNetwork } = useNetworkStore();

  return useCallback(() => {
    if (!selectedNetwork) return;
    for (const scope of CHART_SCOPES) {
      queryClient.invalidateQueries({ queryKey: ["networks", selectedNetwork, scope] });
    }
  }, [queryClient, selectedNetwork]);
}
